import { useEnvironment } from "~/context/EnvironmentContext";

const logos = [
  { src: "logo-hankyu.webp", alt: "阪急阪神第一ホテルグループ" },
  { src: "logo-sasaya.webp", alt: "SASAYAホールディングス" },
  { src: "logo-db.webp", alt: "ドミニク・ブシェ トーキョー" },
  { src: "logo-tanta.webp", alt: "トラットリア タンタボッカ" },
  { src: "logo-liaison.webp", alt: "LIASON Cuisine Francaise" },
  { src: "logo-latte.webp", alt: "LATTE GRAPHIC" },
  { src: "logo-ldh.webp", alt: "LDH" },
  { src: "logo-mercer.webp", alt: "マーサーブランチ" },
  { src: "logo-global.webp", alt: "株式会社グローバルダイニング" },
  { src: "logo-dd.webp", alt: "DDホールディングス" },
  { src: "logo-osho.webp", alt: "餃子の王将" },
];

const Logos = () => {
  // コンテキストから静的画像バケットのエンドポイントを取得
  const { staticImageBucketEndpoint } = useEnvironment();

  // NOTE: className周りでうまく画像取得できない問題があり、環境関係なく本番のR2を見に行くようにしているためコメントアウト
  // 画像URLを変数に格納（classNameで呼び出すため事前に変数に格納）
  //const bgLogosDesktopImageURL = `url(${staticImageBucketEndpoint}/public/top/logos-bg_pc.webp)`;
  //const bgLogosMobileImageURL = `url(${staticImageBucketEndpoint}/public/top/logos-bg_sp.webp)`;

  return (
    <section
      className={`my-14 py-8 bg-primary bg-[url(https://public.fjob-kyujin.com/public/top/logos-bg_sp.webp)] bg-[length:auto_100%] bg-center bg-no-repeat md:my-[104px] md:py-10 md:bg-[url(https://public.fjob-kyujin.com/public/top/logos-bg_pc.webp)]`}
    >
      <div className="md:max-w-[1040px] md:mx-auto md:px-7">
        <h3 className="mb-6 text-2xl text-white text-center leading-normal font-black sp:px-4 md:text-[32px] md:leading-normal md:mb-8">
          取引先企業例
        </h3>
      </div>
      <div className="overflow-hidden">
        <ul className="animate-infiniteScroll flex gap-4 w-fit [&_li]:flex-shrink-0 [&_figure]:block sp:[&_figure]:w-[123px] md:[&_figure]:w-[160px]">
          {/* アニメーションが -50% スクロールした時点で先頭に戻るため、継ぎ目なくループさせるために2セット並べる */}
          {[...logos, ...logos].map((logo, index) => (
            <li key={index} aria-hidden={index >= logos.length || undefined}>
              <figure>
                <img
                  src={`${staticImageBucketEndpoint}/public/top/logos/${logo.src}`}
                  width="160"
                  height="78"
                  alt={index < logos.length ? logo.alt : ""}
                />
              </figure>
            </li>
          ))}
        </ul>
        <div className="mt-4 px-4 md:px-7">
          <p className="text-xs text-white leading-normal md:max-w-[1040px] md:mx-auto md:text-center md:text-sm md:leading-normal">
            *上記はこれまで取引実績のある企業のため、現在も求人を募集している企業とは限りません
          </p>
        </div>
      </div>
    </section>
  );
};

export default Logos;
